// extracted by mini-css-extract-plugin
module.exports = {"preferences":"PersonalDataCategories-module__preferences___V071N","title":"PersonalDataCategories-module__title___YMVyh","row":"PersonalDataCategories-module__row___x1yBg"};